export default __webpack_public_path__ + "img/about_us-75a8949e53acc90edab002530cfa89b8.png";